import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% reducere la articolele selectate',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% reducere la valoarea totală a comenzii',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Articol gratuit cu un articol',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Articol gratuit cu o valoare a comenzii',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Cumpără unul, primești unul la jumătate de preț',
  [OFFER_KIND.BOGO]: 'Cumpără unul, primești unul gratuit',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} reducere la articolele selectate',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} reducere cu o valoare a comenzii',
};
